import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "disabled", "rows", "value"]
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['textarea-container', { disabled: _ctx.disabled }])
  }, [
    _createElementVNode("textarea", {
      id: _ctx.id,
      disabled: _ctx.disabled,
      rows: _ctx.rows,
      value: _ctx.modelValue,
      class: "textarea-input",
      placeholder: " ",
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }, null, 40, _hoisted_1),
    _createElementVNode("label", {
      for: _ctx.id,
      class: "textarea-label"
    }, _toDisplayString(_ctx.label), 9, _hoisted_2)
  ], 2))
}